import { UserAPI } from "@/api/user";
import { Selectors } from "./selectors";
import { Selectors as LocaleSelectors } from "../locale/selectors";
import { Actions } from "./slice";
import { Effects as AuthEffects } from "../auth/effects";
import { detectTimezone } from "@/utils/time";
import pick from "lodash/pick";
import { analyticsAction, getYandexMetrikaClientId } from "@/utils/analytics";
import { Actions as ModalActions } from "../modals/slice";

const sendRegisterRequest = async (state) => {
  const form = Selectors.getForm(state);
  const strategy = Selectors.getStrategy(state);
  const locale = LocaleSelectors.getLocale(state);
  const timezone = detectTimezone();
  const isMaster = Boolean(form.is_master || form.is_saloon_owner);
  const ym_client_id = await getYandexMetrikaClientId();
  const finalForm = {
    ...pick(form, ["first_name", "password", strategy]),
    timezone,
    locale,
    is_saloon_owner: Boolean(form.is_saloon_owner),
    is_client: Boolean(form.is_client),
    is_master: isMaster,
    sex: false,
    ym_client_id,
  };
  await UserAPI.createUser(finalForm);
};
const register = () => async (dispatch, getState) => {
  const stepsAmount = Selectors.getStepsAmount(state);
  const state = getState();
  const form = Selectors.getForm(state);
  await sendRegisterRequest(state);
  if (form.is_saloon_owner) {
    analyticsAction({
      category: "reg",
      action: "saloon_reg",
    });
  }
  if (form.is_master) {
    analyticsAction({
      category: "reg",
      action: "pro_account",
    });
  }
  if (form.is_todo) {
    analyticsAction({
      category: "reg",
      action: "todo_account",
    });
  }
  if (form.is_client) {
    analyticsAction({
      category: "reg",
      action: "todo_client",
    });
  }
  dispatch(Actions.changeStep(stepsAmount + 1));
};
const requestPhoneVerificationCode = () => async (_, getState) => {
  await sendRegisterRequest(getState());
};
const submitPhoneVerificationCode = (code) => async (dispatch) => {
  await UserAPI.verifyPhone(code);
  dispatch(AuthEffects.sessionLogin());
  dispatch(ModalActions.closeAuth());
  dispatch(Actions.reset());
};

export const Effects = {
  register,
  requestPhoneVerificationCode,
  submitPhoneVerificationCode,
};
